/**
 * 发行平台-支付页面-漫画返积分
 */
import React, {useEffect, useState} from 'react';
import './style.scss';
import { computeNumber } from "@/utils/publicFun";

const ReturnPoints = ({data}) => {
  const [points, setPoints] = useState(0);

  useEffect(() => {
    if(data) {
      const newPoints = computeNumber(computeNumber(data.totalPrice, "*", data.pointPercentage).result,"*", data.pointRatio).result;
      setPoints(newPoints);
    }
  }, [data])

  return <div className='comic-point-card'>
    <span className="left-text">持有{data.comicsSet}漫画返{Number(data.pointPercentage)*100}%积分：</span>
    <span className="right-text">+{points}积分</span>
  </div>
}

export default ReturnPoints;
